import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Hats, SpecialHatList } from '../../../@resources/hats';
import { Arr, shuffle } from '../../../CodesForFoundation';
import { LFC } from '../../../Legacy';
import { Image } from '../../../concepts/resources/Image';
import { HatSettings } from '../../packages/hats/HatTypes';

const Frame = styled.div<{ transform: string, mask?: 'front' | 'back' }>`
    position: absolute !important;
    top: 0rem;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translateX(-50%);
    pointer-events: none;

    svg {
        display: block;
        width: 100%;
        transform: ${p => p.transform};
    }
    img {
        display: block;
        width: 100%;
        transform: ${p => p.transform};
        object-fit: contain;
    }

    ${p => p.mask === 'front' && css`
        path, ellipse, line {
            display: inline;
        }
        .back {
            display: none;
        }
    `}
    ${p => p.mask === 'back' && css`
        path, ellipse, line {
            display: none;
        }
        .back {
            display: inline;
        }
    `}
`;

export const Hat: LFC<{ type: string }> = ({ type, children }) => {
    const { mask, scale, x, y } = HatSettings.lookup(type) ?? {};
    const transform = `scale(${scale ?? 0}) translate(${x ?? '0'}, ${y ?? '0'})`;
    return <>
        {!!type && mask && <Frame mask="back" transform={transform}>
            <Image src={Hats[type]} />
        </Frame>}
        {children}
        {!!type && <Frame mask="front" transform={transform}>
            <Image src={Hats[type]} />
        </Frame>}
    </>;
};

export const RandomHat: LFC = ({ children }) => {
    const type = useMemo(() => randomHat(), []);
    return <Hat type={type}>{children}</Hat>;
};

export const randomHat = (() => {
    const shuffled = shuffle(Object.keys(Hats).filter(x => !SpecialHatList.includes(x)));
    let i = 0;
    return () => Arr.at(shuffled, i++);
})();
